import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmailToNamePipe } from "./shared/pipes/emailToName.pipe";
import { CheckUserQuery } from './interfaces/interfaces';
import { AuthService } from "./services/auth.service";
import { BehaviorSubject } from "rxjs";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
    providedIn: 'root'
})
export class UserService {

    public query: CheckUserQuery;
    public currentUser: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private http: HttpClient,
        private authService: AuthService
        ) { }

    //baseServerUrl = "https://testsite.achievepro.co.uk/api/auth/"; // Live
    baseServerUrl = "https://localhost:7035/api/auth"; //Local

    jwtHelperService = new JwtHelperService();

    public registerUser(user: Array<string>){
        return this.http.post(this.baseServerUrl + "CreateUser" , {
            Name: user[0],
            Email: user[1],
            UserName: user[2],
            Password: user[3],
            Role: user[4],
            LoggedOn: false,
        }, {
            responseType: 'text',
        });
    }

    setToken(token: string)
    {
        localStorage.setItem("access_token", token);
        this.loadCurrentUser();
    }
    
    loadCurrentUser(){
        const token = localStorage.getItem("access_token");
        const userInfo = token != null ? this.jwtHelperService.decodeToken(token) : null;

        console.log(userInfo);
        const data = userInfo ? {
            id: userInfo.id,
            name: userInfo.name,
            userName: userInfo.userName,
            email: userInfo.email,
            role: userInfo.role
        } : null;
        this.currentUser.next(data);
        localStorage.setItem('currentUser', JSON.stringify(data));
        ///localStorage.setItem('currentId',data.id);
        //alert(localStorage.getItem('currentId'));
        ///localStorage.setItem('currentUser',data.name);
        ///localStorage.setItem('currentRole',data.role);
        ///localStorage.setItem('currentEmail',data.email);
        ///localStorage.setItem('currentUserName',data.userName);
        //alert(localStorage.getItem('currentUserName'));
        //alert(localStorage.getItem('currentRole'));
        //console.log(localStorage.getItem('currentUser'));
    }

    isLoggedIn(): boolean{
        return localStorage.getItem("access_token") ? true : false;
    }

    removeToken() {
        localStorage.removeItem("access_token");
    }

    public loginUser(loginInfo: Array<string>){

        this.query = {};
        this.query.userName = loginInfo[0];
        this.query.password = loginInfo[1];
        alert(this.query.userName + ' ' + this.query.password);
        alert(this.query);

        return this.http.post(this.baseServerUrl + "LoginUser" , {
            command: this.query,
        }, {
            responseType: 'text',
        });
    }
}